import React from "react";
interface DashboardFlightCardProps {
  imageUrl: string;
  origin: string;
  destination: string;
  flightType?: "Direct Flight" | "One Stop" | "Multi-stop";
  duration: string;
  stops?: string;
  currentPrice: number;
  originalPrice?: number;
  currency?: string;
  onBook?: () => void;
  className?: string;
}
const DashboardFlightCard = ({
  currentPrice,
  destination,
  duration,
  imageUrl,
  origin,
  className,
  currency,
  flightType,
  onBook,
  originalPrice,
  stops,
}: DashboardFlightCardProps) => {
  const handleBookClick = () => {
    if (onBook) {
      onBook();
    } else {
      console.log(`Booking flight from ${origin} to ${destination}`);
    }
  };
  const getChipColor = () => {
    switch (flightType) {
      case "Direct Flight":
        return "MuiChip-colorPrimary MuiChip-filledPrimary";
      case "One Stop":
        return "MuiChip-colorSecondary MuiChip-filledSecondary";
      case "Multi-stop":
        return "MuiChip-colorDefault MuiChip-filledDefault";
      default:
        return "MuiChip-colorPrimary MuiChip-filledPrimary";
    }
  };

  const formatPrice = (price: number) => {
    return `${currency}${price.toLocaleString()}`;
  };

  return (
    <div className={` shadow-sm h-100 card ${className}`}>
      <div style={{ height: 120, overflow: "hidden" }}>
        <img
          className="card-img-top"
          src={imageUrl}
          alt={`Flight from ${origin} to ${destination}`}
          style={{ height: "100%", objectFit: "cover" }}
        />
      </div>
      <div className="p-3 card-body">
        <div
          className={`MuiChip-root MuiChip-filled MuiChip-sizeSmall ${getChipColor()} mb-2`}
        >
          <span className="MuiChip-label MuiChip-labelSmall">{flightType}</span>
        </div>
        <h6 className="fw-semibold mb-1">
          {origin} ✈ {destination}
        </h6>
        <small className="text-muted d-flex align-items-center mb-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-calendar me-1"
          >
            <path d="M8 2v4" />
            <path d="M16 2v4" />
            <rect width={18} height={18} x={3} y={4} rx={2} />
            <path d="M3 10h18" />
          </svg>
          {duration} • {stops}
        </small>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <span className="fw-bold text-success">
              {formatPrice(currentPrice)}
            </span>
            {originalPrice && originalPrice > currentPrice && (
              <small className="text-muted text-decoration-line-through ms-1">
                {formatPrice(originalPrice)}
              </small>
            )}
          </div>
          <button
            type="button"
            className="btn btn-primary btn-sm seat-btn-color"
            onClick={handleBookClick}
          >
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardFlightCard;
